module.exports = __webpack_public_path__ + "img/auth-banner.0951db50.png";